import routes from 'app/partner/routes';

export default {
  routes,
};
